import axios from 'axios';

const baseURL = 'https://nyiorclement.pythonanywhere.com/api/';

export default axios.create({
  baseURL
});
